"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapArrayToLiteralTuple = void 0;
const zod_1 = require("zod");
/**
 * This function is necessary due to Zod's union type not
 * liking union inputs and preferring arrays of tuples.
 * It likes [z.ZodLiteral<1>, z.ZodLiteral<2>] instead of
 * z.ZodLiteral<1 | 2>[] which is fine because it expects
 * at least 2 elements.
 */
const mapArrayToLiteralTuple = (input) => {
    return input.map((value) => zod_1.z.literal(value));
};
exports.mapArrayToLiteralTuple = mapArrayToLiteralTuple;
//# sourceMappingURL=typing_utils.js.map